import { forwardRef } from "react";

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export const ButtonIconos = forwardRef<HTMLButtonElement, Props>(
  ({ children, className = "", type = "button", ...props }, ref) => {
    return (
      <button
        ref={ref}
        type={type}
        className={`
          inline-flex items-center justify-center
          w-10 h-10 sm:w-12 sm:h-12
          box-border border-2 border-zinc-300
          rounded-md bg-zinc-600 text-white
          shadow-sm shadow-blue-500
          transition-colors duration-300
          hover:border-blue-700
          active:bg-white active:text-black active:font-extrabold
          ${className}
        `}
        {...props}
      >
        <span className="flex items-center justify-center w-full h-full">
          {children}
        </span>
      </button>
    );
  }
);


ButtonIconos.displayName = "ButtonSiguiente";

export default ButtonIconos;
